import { useAuth } from '../state/auth';

/**
 * 离线用户的展示名缓存（悬停笔画作者等场景）。
 * 在线用户走 presence（实时），查不到的用这里：按需 GET /api/users/:id/name，
 * 模块级 Map + inflight 去重，进程内只查一次。
 */
const cache = new Map<string, { name: string; color: string } | null>();
const inflight = new Map<string, Promise<{ name: string; color: string } | null>>();
const MAX = 2000;

export function getCachedUserName(userId: string): { name: string; color: string } | null | undefined {
  return cache.get(userId);
}

export async function fetchUserName(userId: string): Promise<{ name: string; color: string } | null> {
  if (cache.has(userId)) return cache.get(userId)!;
  let p = inflight.get(userId);
  if (!p) {
    p = (async () => {
      try {
        const token = useAuth.getState().token;
        const r = await fetch(`/api/users/${encodeURIComponent(userId)}/name`, {
          headers: token ? { authorization: `Bearer ${token}` } : undefined,
        });
        if (!r.ok) return null;
        return (await r.json()) as { name: string; color: string };
      } catch {
        return null;
      }
    })();
    inflight.set(userId, p);
  }
  const out = await p;
  inflight.delete(userId);
  if (cache.size >= MAX) {
    // 简单防膨胀：超限全清（悬停热点会立刻重新填上）
    cache.clear();
  }
  cache.set(userId, out);
  return out;
}
